import { render, staticRenderFns } from "./GetKnow.vue?vue&type=template&id=b9f51e64&scoped=true&"
import script from "./GetKnow.vue?vue&type=script&lang=js&"
export * from "./GetKnow.vue?vue&type=script&lang=js&"
import style0 from "./GetKnow.vue?vue&type=style&index=0&id=b9f51e64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f51e64",
  null
  
)

export default component.exports